import React from "react";

/**
 * Returns an onKeyDown handler that activates a control with Enter or Space,
 * mirroring native <button> behaviour. Use on interactive elements that must
 * stay a non-button tag for styling/layout reasons (e.g. a clickable <div>,
 * <span>, <svg> or <img>) but still need to be keyboard-operable (WCAG 2.1.1).
 *
 * Usage (purely additive, no layout change):
 *   <div
 *     className="card"
 *     role="button"
 *     tabIndex={0}
 *     onClick={open}
 *     onKeyDown={activateOnKey(open)}
 *   >
 *
 * The handler is intentionally loosely typed so it accepts the existing
 * `() => void` / `(e: MouseEvent) => void` onClick callbacks unchanged.
 */
export const activateOnKey =
  (handler: (event?: any) => void) =>
  (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault();
      handler(event);
    }
  };
